import { FormContext, FormContextManager, IFormContext } from "config/FormContext"
import { useRef, useState } from "react"
import { useContext } from "react";	
import { getAppContext } from 'config/AppContext';
import { useTranslation } from "react-i18next";

type BaseFormPropsType = {
    id?: string,
    name: string,
    children: React.ReactNode | React.ReactNode[]
}

type BaseFormPropsTypeVoid = BaseFormPropsType & {
    onSubmit: (e: React.FormEvent<HTMLFormElement>) => void
    onReset?: (e: React.FormEvent<HTMLFormElement>) => void
    onError?: (e: React.FormEvent<HTMLFormElement>) => void
}

type FormPropsTypePromise = BaseFormPropsType & {
    onSubmit: (e: React.FormEvent<HTMLFormElement>) => Promise<void>
    onReset?: (e: React.FormEvent<HTMLFormElement>) => Promise<void>
    onError?: (e: React.FormEvent<HTMLFormElement>) => Promise<void>
}

export type FormPropsType = BaseFormPropsTypeVoid | FormPropsTypePromise


const Form = (props: FormPropsType) => {
    const [t] = useTranslation();
    const formElement = useRef<HTMLFormElement>(null);
    const context = getAppContext(useContext);
    // #region context
    const [formContext, setFormContext] = useState<IFormContext>({
      submitted: false
    });
  
    const manager = new FormContextManager(formContext, setFormContext as (i: Partial<IFormContext>) => void);

    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();
        formElement.current!.classList.add('submitted');
        manager.submitted = true;
        if (e.currentTarget.checkValidity()) {
            props.onSubmit(e);
        } else {
            context.notify('error', t('form.errors.invalidData'));
            if (typeof props.onError == 'function') {
                props.onError(e);
            }
        }
    };

    const onReset = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        e.stopPropagation();
        formElement.current!.classList.remove('submitted');
        manager.submitted = false;
        if(props.onReset) {
            const resetResult = props.onReset(e);
            if (resetResult instanceof Promise) {
                resetResult.then();
            }
        }
    };

    return (
        <FormContext.Provider value={manager}>
            <form noValidate ref={formElement} onReset={onReset} onSubmit={onSubmit} id={props.id} name={props.name} autoComplete="off">
                {props.children}
            </form>
        </FormContext.Provider>
    );
};

export default Form;
